import React, {useEffect, useState} from 'react';
import {useNavigate, useParams} from 'react-router-dom';
import {Box, Button, CircularProgress, Typography} from '@mui/material';
import CheckCircleOutlineIcon from '@mui/icons-material/CheckCircleOutline';
import ErrorOutlineIcon from '@mui/icons-material/ErrorOutline';
import {useClient} from '../core/client';
import {useAuth} from "../auth-context";
import {signInWithCustomToken} from "firebase/auth";
import {auth} from "../core/firebase";
import axios from "axios";

const Confirmation = () => {
    const { sessionId } = useParams();
    const [status, setStatus] = useState('loading');
    const [message, setMessage] = useState('');
    const client = useClient();
    const { login } = useAuth();
    const navigate = useNavigate();

    useEffect(() => {
        const fetchStatus = async () => {
            try {
                // Replace with your backend endpoint that checks Stripe session
                const { data } = await client.get(`/auth/checkout/${sessionId}`);
                if (data.checkout_status === 'complete') {
                    await login(data);
                    await signInWithCustomToken(auth, data.firebase_token);
                    if (data.access_token) {
                        try {
                            await axios.get(`${process.env.REACT_APP_API_URL}/auth/billing/subscription`, {
                                headers: {
                                    Authorization: `Bearer ${data.access_token}`,
                                },
                            });
                        } catch (e) {
                            // Non-blocking: profile will fetch again later.
                        }
                    }
                    setStatus('success');
                    setMessage('Payment successful! Thank you for your purchase.');
                    navigate('/');
                } else {
                    setStatus('error');
                    setMessage('Payment not completed. Please try again.');
                }
            } catch (err) {
                setStatus('error');
                setMessage('There was an error confirming your payment.');
            }
        };
        fetchStatus();
    }, [sessionId, client, login, navigate]);

    if (status === 'loading') {
        return (
            <Box display="flex" flexDirection="column" alignItems="center" mt={8}>
                <CircularProgress />
                <Typography variant="h6" mt={2}>Confirming your payment...</Typography>
            </Box>
        );
    }

    return (
        <Box display="flex" flexDirection="column" alignItems="center" mt={8}>
            {status === 'success' ? (
                <>
                    <CheckCircleOutlineIcon color="success" sx={{ fontSize: 60 }} />
                    <Typography variant="h5" mt={2}>{message}</Typography>
                    <Button href="/" variant="contained" sx={{ mt: 3 }}>Go to Dashboard</Button>
                </>
            ) : (
                <>
                    <ErrorOutlineIcon color="error" sx={{ fontSize: 60 }} />
                    <Typography variant="h5" mt={2}>{message}</Typography>
                    <Button href="/" variant="contained" sx={{ mt: 3 }}>Return Home</Button>
                </>
            )}
        </Box>
    );
};

export default Confirmation;
